// apolloClient.ts
import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  createHttpLink,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getCookie } from "../../helpers/localStorage";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import { onToastError } from "../../helpers/utils";

// uri: 'http://api.eneotransportation.com', //dev uat
// 👉 Lien vers ton serveur GraphQL
const httpLink = createHttpLink({
  uri: 'https://dev.api.lewootrack.com', //prod
  // uri: "https://dev.api.lewootrack.com", //dev qa-mimisets
  // uri: 'https://api-dev.eneotransportation.com',
});

// 👉 Middleware pour ajouter le token à chaque requête
const authLink = setContext((_, { headers }) => {
  // Récupère le token du localStorage (ou autre stockage)
  const token = getCookie("token");
  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbklkIjoxMywidXNlcm5hbWUiOiJBZnJpY2FCdXNpbmVzcyIsInJvbGVzIjoiQlVTSU5FU1NBRE1JTiIsImlhdCI6MTc0Nzk4ODgxNiwiZXhwIjoxNzQ4MDc1MjE2fQ.dTnPiLRhCqZb1HfRe4YK8dqf_piiNgSubi8ElAuPE04";
  // console.log('Token:', token, httpLink);
  return {
    headers: {
      ...headers,
      Authorization: token
        ? `Bearer ${token}`
        : "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbklkIjoxMTcyLCJ1c2VybmFtZSI6ImVuZW90cmFjayIsInJvbGVzIjoiQ0xJRU5UIiwiaWF0IjoxNzI4NTU0NDcxfQ.g4WzrK9Lu2UODOyKBF6VAclJan-ySCXnDCOvN18Jqgg",
    },
  };
});

// uri: 'wss://api.eneotransportation.com',

const wsLink = new WebSocketLink({
  uri: 'wss://dev.api.lewootrack.com',
  // uri: "wss://dev.api.lewootrack.com",
  // uri: 'wss://api-dev.eneotransportation.com',
  options: {
    reconnect: true,
    lazy: true,
    connectionParams: () => ({
      Authorization: getCookie("token")
        ? `Bearer ${getCookie("token")}`
        : "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbklkIjoxMTcyLCJ1c2VybmFtZSI6ImVuZW90cmFjayIsInJvbGVzIjoiQ0xJRU5UIiwiaWF0IjoxNzI4NTU0NDcxfQ.g4WzrK9Lu2UODOyKBF6VAclJan-ySCXnDCOvN18Jqgg",
    }),
  },
});

wsLink.subscriptionClient.onReconnecting(() => {
  const authStatus = getCookie("token");

  if (!authStatus) {
    wsLink.subscriptionClient.unsubscribeAll();
    wsLink.subscriptionClient.close();
  }
});

const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  wsLink,
  authLink.concat(httpLink)
);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const isDbConnectionLimitError = (message = "") =>
    message.includes("too many clients already") ||
    message.includes("remaining connection slots are reserved");

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      if (isDbConnectionLimitError(message)) {
        console.warn(`[GraphQL warning]: ${message}`);
        return;
      }

      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }
  if (networkError) {
    console.log(`[Network error]: ${JSON.stringify(networkError)}`);
    onToastError(
      networkError.message +
        " \n \n" +
        networkError.result?.errors?.[0]?.message
    );
  }
});

const logoutLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      if (error.message.toLowerCase().includes("auth")) {
        // logout()
      }
    });
  }
});

const client = new ApolloClient({
  link: ApolloLink.from([
    ...(process.env.NODE_ENV !== "production" ? [errorLink] : []),
    logoutLink,
    link,
  ]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
    },
    query: {
      errorPolicy: "all",
    },
  },
});
// // 👉 Création du client Apollo
// const client = new ApolloClient({
//     link: authLink.concat(httpLink), // Ajout du lien auth avant le httpLink
//     cache: new InMemoryCache(),
// });

export default client;
